<template>
    <div class="myadvisor-container">
        <img class="bg" :src="BG" alt="BG">
        <img class="people" :src="People" alt="People">

        <div class="btn-container">
            <router-link 
                tag="button" :to="{ name: 'MyAdvices' }" 
                class="btn btn-primary advice-btn">
                <img :src="MSG" alt="MSG">
                <span>مشاوره‌های من ({{ advices }})</span>
            </router-link>

            <router-link 
                tag="button" :to="{ name: 'MyRequests' }" 
                class="btn btn-primary advice-btn">
                <img :src="Timer" alt="Timer">
                <span>درخواست‌های من ({{ requests }})</span>
            </router-link>

            <small>انجام مشاوره های تخصصی آنلاین در حوزه های مختلف به صورت ویدیویی و کتبی، و همچنین امکان ثبت درخواست برای مشاوره های حضوری و تلفنی</small>
        
            <router-link
                tag="button"
                :to="{ name: 'Advisor' }" 
                class="btn btn-outline-light btn-new"
            >ثبت درخواست جدید</router-link>
        </div>
    </div>
</template>

<script>
import BG from '@/assets/images/advisor/bg.png';
import People from '@/assets/images/advisor/people.png';

import MSG from '@/assets/images/advisor/msg.png';
import Timer from '@/assets/images/advisor/timer.png';

import { getRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'MyAdvisor',
    data() {
        return {
            BG: BG,
            People: People,

            MSG: MSG,
            Timer: Timer,

            requests: 0,
            advices: 0
        }
    },
    mounted() {
        this.Get()
    },
    methods: {
        // get current item's data
        Get() {
            getRequest('/advice-requests/find-users-all')
                .then((rsp) => {
                    // response
                    let data = rsp['data'];

                    data.forEach(item => {
                        item.State == 'check' ? this.requests++ : this.advices++;
                    });
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.myadvisor-container {
    width: 100%;

    position: relative;
    background-color: #2ad85f;
}
.myadvisor-container .bg {
    width: 275pt;

    position: absolute;
    top: -50pt;
    left: -50pt;
}
.myadvisor-container .people {
    width: 100vw;
    max-width: 250pt;

    position: absolute;
    top: 10pt;
    left: -10pt;
}

/* ---------------------------------------- */
/* ------------- BTN CONTAINER ------------ */
/* ---------------------------------------- */
.myadvisor-container .btn-container {
    min-height: calc(100vh - 325px);
    width: 100%;
    
    position: absolute;
    top: 225px;
    left: 0;

    display: flex;
    flex-wrap: wrap;
}
.myadvisor-container .btn-container small {
    max-width: 300pt;
    padding: 0 10pt;
    margin: 5pt auto auto;

    color: #fff;
    text-align: center;
}
.myadvisor-container .btn-container .btn-new {
    width: 80vw;
    margin: auto 10vw 0;

    color: #fff;
    text-align: center;
    line-height: 2rem;
}
.myadvisor-container .btn-container .btn-new:hover {
    color: #24327c;
}
.myadvisor-container .btn-container .advice-btn {
    width: 45%;
    height: calc(25vh - 25pt);
    margin: 0 auto;

    border-radius: 15pt;
    color: #24327c;
    border-color: #fff;
    background-color: #fff;
}
.myadvisor-container .btn-container .advice-btn img {
    width: 30pt;
    margin: auto auto 10pt;
    display: block;
}
.myadvisor-container .btn-container .advice-btn span {
    font-size: 12px;
    font-weight: bold;
}
</style>
